import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";

import IconSelector from "components/shared/images/IconSelector";
import AppModal from "components/shared/modal/AppModal";

import { postInstallGlusterFS } from "redux/handlers/clusterHandler";

import { useAppDispatch } from "hooks/reduxHook";

const GlusterFSSetup = ({ id, hasNetwork = false }: { id: number; hasNetwork: boolean }) => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const [openModal, setOpenModal] = useState<boolean>(false);
 const [loading, setLoading] = useState<boolean>(false);

 const handleOpen = () => setOpenModal(true);
 const handleClose = () => setOpenModal(false);

 const handleConfirm = async () => {
  setLoading(true);
  await dispatch(postInstallGlusterFS(id));
  setLoading(false);
  handleClose();
 };

 return (
  <>
   <Tooltip title={intl.formatMessage({ id: "cluster.glusterfsSetup" })} placement="bottom">
    <IconButton onClick={handleOpen}>
     <IconSelector icon="GlusterfsIcon" props={{ color: "kxOrange" }} />
    </IconButton>
   </Tooltip>
   <AppModal
    open={openModal}
    close={handleClose}
    title={intl.formatMessage({ id: "cluster.glusterfsSetup" })}
    handleClose={handleClose}
    disabled={loading || !hasNetwork}
    handleConfirm={handleConfirm}>
    <Stack spacing={2}>
     <Typography variant="subtitle2">
      <FormattedMessage
       id="cluster.glusterfsSetupMessage"
       values={{
        guide: (
         <a
          href={`${process.env.PUBLIC_URL}/documents/guides/node_setup.html`}
          target="_blank"
          rel="noreferrer">
          {intl.formatMessage({ id: "container.maildomains.configGuideLink" })}
         </a>
        )
       }}
      />
     </Typography>
     {!hasNetwork && (
      <Alert severity="error">
       <Typography variant="subtitle2">
        <FormattedMessage id="server.notConnectedToNetwork" />
       </Typography>
      </Alert>
     )}
    </Stack>
   </AppModal>
  </>
 );
};

export default GlusterFSSetup;
